import PanelCollapse from 'src/componentes/panel-collapse';

export default function HistoricoView({ intl, historico }) {
  if (!historico || historico.length == 0) return null;

  return (
    <PanelCollapse header={intl.formatMessage({ id: 'labelHistoricoStatus' })}>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>{intl.formatMessage({ id: 'labelResponsavel' })}</th>
            <th>{intl.formatMessage({ id: 'status' })}</th>
            <th>{intl.formatMessage({ id: 'justificativa' })}</th>
            <th>{intl.formatMessage({ id: 'labelDataAlteracao' })}</th>
          </tr>
        </thead>
        <tbody>
          {historico?.map((item, index) => (
            <tr key={index}>
              <td>{item.responsavelAlteracao}</td>
              <td>{item.status}</td>
              <td>{item.justificativa ? item.justificativa : '-'}</td>
              <td>{item.dataAlteracao}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </PanelCollapse>
  );
}
